var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-cascader',_vm._b({attrs:{"options":_setup.props.options,"field-names":_setup.props.fieldNames},on:{"change":_setup.change},model:{value:(_setup.data),callback:function ($$v) {_setup.data=$$v},expression:"data"}},'a-cascader',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }